<template>
  <v-dialog
      content-class="login"
      v-model="visible">
    <v-card class="login__body">
      <v-card-title>서비스를 이용하기 위해서 로그인이 필요합니다</v-card-title>
      <v-card-text>
        <vue-kakao-login
            ref="kakaoLogin"
            :api-key="kakaoApiKey"
            :on-success="onSuccess"
            :on-failure="() => {}"
        ></vue-kakao-login>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import visualComponent from "@/mixins/visualComponent";
import VueKakaoLogin from 'vue-kakao-login';
import { getPlayerByKakaoId } from "@/api/player";
import kakao from '@/mixins/kakao';

export default {
  name: "Login",
  mixins: [visualComponent, kakao],
  components: {
    VueKakaoLogin
  },
  methods: {
    onSuccess(data) {
      const self = this
      console.debug('kakao login success', data)

      this.kakaoRequest('/v2/user/me').then(async data => {
        console.debug(data)
        const kakaoId = data.id
        const player = await getPlayerByKakaoId(kakaoId)
        if(player){
          await self.$store.dispatch('auth/login', player)
          self.$emit('login', player)
        } else {
          await self.$store.dispatch('auth/setKakaoData', data)
          await this.$router.replace({path:'/user',query:{new:true}})
          await this.$alert('유저등록을 해주세요','연동된 계정 없음','warning')
          this.visible = false
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .login{
    max-width:500px;

    .v-card__text{
      display:flex;
      justify-content: center;
    }

    #kakao-login-btn{
      height: 50px;
      cursor: pointer;
    }
    &__body{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height:100%;
      width:100%;
    }
  }
</style>